import React from "react";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function AggiungiParametri({
    nomeIT,
    nomeEN,
    nomeFR,
    handleChange
}) {

    

    return <div className="">
    <div className="titoli">
        <h3 className="">parametri IT</h3>
        <input type="text" id="it" name="it" value={nomeIT} onChange={handleChange} className={stilePulsanti.inputClasses} />
        <h3 className="">parametri EN</h3>
        <input type="text" id="en" name="en" value={nomeEN} onChange={handleChange} className={stilePulsanti.inputClasses} />
        <h3 className="">parametri FR</h3>
        <input type="text" id="fr" name="fr" value={nomeFR} onChange={handleChange} className={stilePulsanti.inputClasses} />
    </div>
</div>
    
}

export default AggiungiParametri;